import React from 'react'
import {Trans} from '@lingui/macro'
import {Button} from 'components/UI/Button/Button'



// Type
export type typeDZReportsActions = {
    onClickExport: () => void
}


// Component
export const DZReportsActions: React.FC<typeDZReportsActions> = ({onClickExport}) => {
    return(
        <>
            <Button buttonClassName="flex-initial"  secondary={true} type="button"  label={<Trans>Export all Z-reports</Trans>} onClick={onClickExport}/>
        </>
    )
}
